<div class="job-container">

  <div class="non-active-row">
    <div *ngTemplateOutlet="jobTemplate"></div>
  </div>

  <common-mojo-card [elevation]="elevation">
    <div *ngTemplateOutlet="jobTemplate"></div>
  </common-mojo-card>

</div>

<ng-template #jobTemplate>
  <div class="job-template">
    <div class="job-info">
      <div class="job-title-container">
        <mojo-item-index-ellipse [index]="index + 1"></mojo-item-index-ellipse>
        <mojo-best-job *ngIf="index===0"></mojo-best-job>
        <a [routerLink]="['/jobs', 'job', job.id]">
          <span>
            {{job.title}}
          </span>
        </a>
      </div>
      <mojo-job-location [locations]="job.locations">
      </mojo-job-location>
    </div>

    <mojo-move-forward-button
      [candidate]="candidate"
      [jobId]="job?.id"
      *mojoHasPrivilege="privileges.associate.candidate_to_job"
    >
    </mojo-move-forward-button>
  </div>
</ng-template>
